import { supabase } from "../supabase/SupabaseClient";

/* Qué unidades están HOY adentro de un taller (#114, pedido de Aldo).
 *
 * Un camión en el taller no puede figurar «Activo» a secas en el padrón: Aldo
 * lo quiere ver como CONDICIONAL. Y la decisión de fondo está en el ticket: se
 * CALCULA al mirar, nunca se escribe en `tractores.estado`. Escrito, se
 * desincroniza el día que el taller lo libere y nadie toque el padrón — y
 * queda un camión «Condicional» que ya está en la ruta, sin fallar en ningún
 * lado. Calculado es lo que no se rompe solo.
 *
 * LA DEFINICIÓN ES LA DE FLOTABOT, NO UNA NUEVA: «está en el taller» es tener
 * una estadía abierta en `taller_estadias` (entrada sin salida) — exactamente
 * lo que usa `movimientos_reglas.trabas_de_taller` del bot para frenar una
 * carga. Un ticket abierto NO alcanza: es trabajo pendiente, y el camión puede
 * estar rodando mientras espera el repuesto. Dos definiciones de «en taller»
 * entre el bot y el hub es cómo se llega a que el hub pinte Condicional un
 * camión que el bot deja cargar.
 *
 * El interno viene con la convención del taller: tractor pelado («604») y
 * furgón con F adelante («F308») — la misma de `shared/unidad`.
 */
export async function getEnTaller() {
  const { data, error } = await supabase
    .from("taller_estadias")
    .select("id, interno, motivo, lugar")
    .is("salida", null);
  if (error) throw error;
  return data || [];
}
